"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.versionWithPlatform = exports.currentVersion = void 0;
var currentVersion = exports.currentVersion = '9.1.0';
var versionWithPlatform = exports.versionWithPlatform = "".concat(currentVersion, "-web");